// //for some reason removing this import breaks plugins
// import $ from '../../../../../core/assets/vendor/jquery/jquery.min.js?v=2.1.4';
import {bodyNoScroll} from '../utils/utilities.js';
/* eslint-disable */
import featherlight from '../libs/featherlight.js';
/* eslint-enable */
var $ = jQuery;

function slideshowInit() {
  var sliderClass = '.slideshow__featherlight .slick-slider';

  function updateCurrent(event, slick, currentSlide) {
    var slideIndex = slick.currentSlide + 1;
    $('.slideshow__featherlight .count__current').text(slideIndex);
    focusSlider();
  }

  function initTotal(event, slick) {
    var totalSlides = slick.slideCount;
    $('.slideshow__featherlight .count__total').text(totalSlides);
  }

  function focusSlider() {
    $('.slick-list').attr('tabindex', 0).focus();
  }

  if($('.slideshow').length) {
    $('.slideshow__trigger-container').featherlight('#slideshow-featherlight__target', {
      variant: 'slideshow__featherlight',
      otherClose: '.event__close-modal',
      afterOpen: function(event) {
        $(sliderClass).on('init reInit afterChange', updateCurrent).on('init', initTotal);
        $(sliderClass).not('.slick-initialized').slick({
          infinite: true,
          adaptiveHeight: true,
          prevArrow: '.slideshow-lightbox__prev',
          nextArrow: '.slideshow-lightbox__next'
        });
        focusSlider();
        bodyNoScroll();
      },
      afterClose: function(event) {
        bodyNoScroll();
      }
    });
  }
}




export { slideshowInit };
